<div id="subscribe-wecdev-container" class="container">
    <div class="text-center">
        <h1>
            <img src="@imagesDir/social-media.png" alt="---social-media---" title="" />
        </h1>
        <hr />
        <br />
        <br />
        <p class="text-muted">
            <b [translate]="'common.subscribe'"></b> -
            <span [translate]="'subscribe_wecdev.text'"></span>
        </p>
        <ul class="list-inline list-social">
            <li class="list-inline-item social-twitter">
                <a [href]="twitterUrl" target="blank">
                    <i class="bi bi-twitter"></i>
                </a>
            </li>
            <li class="list-inline-item social-facebook">
                <a [href]="facebookUrl" target="blank">
                    <i class="bi bi-facebook"></i>
                </a>
            </li>
        </ul>
    </div>
</div>
